export default "__VITE_ASSET__0cfc804a__"